export default {
  labels: {
    title: 'Relación de envío',
    searchBar: 'Buscar por número de relación de envío o número de factura',
    statuses: 'Estado',
    originInvoiceGroupId: 'Número de relación de envío',
    path: 'Ruta',
    status: 'Estado',
    settlementNumber: 'ID Radicación',
    detailTitle: 'Detalle de relación de envío',
    generalInformation: 'Información general',
    files: 'Archivos Rips',
    invoices: 'Facturas',
    extension: 'Extensión',
    fileName: 'Nombre de archivo',
    invoiceNumber: 'Número de factura',
    packageStatus: 'Estado de paquete',
    externalId: 'Guia',
    actions: 'Acciones',
    packageFolderConfiguration: 'Configuración de encarpetamiento',
    generateAccountButton: 'Armar relación de envío',
    reGenerateAccountButton: 'Rearmar relación de envío',
  },
  dialogText: {
    generateAccount: {        
      title: '¿Desea armar la relación de envío?',
      subtitle: 'Esta relación de envío tiene ({count}) factura para armar ¿está seguro que desea proceder? Esta acción no se puede deshacer o detener. | Esta relación de envío tiene ({count}) facturas para armar ¿está seguro que desea proceder? Esta acción no se puede deshacer o detener.',
    },
    preSettlementAction: {
      title: '¿Desea realizar esta acción con las facturas de esta relación de envío?',
      subtitle: 'Esta relación de envío tiene ({count}) factura para procesar ¿Está seguro que desea proceder? | Esta relación de envío tiene ({count}) facturas para procesar ¿Está seguro que desea proceder?',
    },
    preSettlementRipsValidationErrors: {
      title: '¿Desea actualizar el estado de la relación de envío?',
      subtitle: 'La relación de envió se marcará con el estado de error en validación de archivos RIPS. ¿Está seguro que desea proceder?',
    }
  },
  statuses: {
    PENDING: 'Pendiente',
    READY_TO_GENERATE: 'Listo para generar',
    GENERATED: 'Generado',
    SETTLED: 'Radicado',
    SENT: 'Enviado',
    VOIDED: 'Anulado',
    RIPS_VALIDATION_ERRORS: 'Error en validación de archivos RIPS',
  },
  actions: {
    setAccountsAsPackageGenerated: 'Mover a Generado',
    setAccountsAsSettled: 'Mover a Radicado',
    setAccountsAsSent: 'Mover a Enviado',
    setAccountsAsRipsValidationErrors: 'Mover a Error en validación de archivos RIPS',
  },
  errors: {
    downloadFile: 'Ocurrió un error al descargar el archivo. Por favor, intente de nuevo o contacte a su equipo de soporte técnico.',
  },
  package: {
    globalConfigurationHint: 'Esta configuración se aplica a todos los convenios que no tengan una ruta específica',
    configurationByAgreement: 'Configuración por convenio',
    generalConfiguration: 'Configuración general',
    addConfigurationByAgreement: 'Agregar configuración por convenio',
    deleteWarning: '¿Está seguro que desea eliminar la configuración?',
    deleteWarningMessage: 'La configuración será reemplazada por la configuración general',
    duplicatedAgreement: '¿Estás seguro que deseas reemplazarlo? Esto cambiará la configuración de encarpetamiento del convenio {agreementCodes}',
    headers: {
      agreementCodes: 'Códigos de convenio',
      path: 'Directorio',
      actions: 'Acciones'
    }
  }
}
